import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import calculatorMathUtility from '@sparta.credit-cards.utilities/calculator-math-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { select } from '@sparta.global.helpers/select-helper/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { htmlEscaper, updateApplyNowUrl } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';

const Template$5 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "<div class=\"engagement-section\"></div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"showEngagementSection") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":0},"end":{"line":8,"column":7}}})) != null ? stack1 : "")
    + "<div class=\"row\">\r\n  <div class=\"column small-12 top-container hidden\">\r\n    <a id=\"rewardsCalcCcModule\"></a>\r\n    <a id=\"headlineCcalcModule\"><!-- Allow for backwards compatibility with anchor tags from pcm --></a>\r\n    <div class=\"headline-section\">\r\n    </div>\r\n    <div class=\"slider-section\">\r\n    </div>\r\n    <div class=\"bargraphs-section\">\r\n    </div>\r\n    <div class=\"card-display-section\">\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div  id=\"rewards-calc-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":28,"column":42},"end":{"line":28,"column":56}}}))
    + "\"></div>\r\n\r\n";
},"useData":true});
const renderTemplate$5 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$5(data, options);
};

const Template$4 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div>\r\n    <section class=\"calc-row row "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "\">\r\n      <div class=\"column small-12 medium-3 large-3 remove-padding\">\r\n        <div class=\"row remove-padding\">\r\n          <div class=\"column small-12 remove-padding\">\r\n            <img src=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"contentRoot") : stack1), depth0)) != null ? stack1 : "")
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0)) != null ? stack1 : "")
    + "\" alt=\"\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"column small-12 medium-9 large-9 remove-padding\">\r\n        <div class=\"row remove-padding\">\r\n          <div class=\"column small-12 remove-padding\">\r\n            <h3 data-font=\"cnx-regular\" class=\"title-color\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n          </div>\r\n          <div class=\"column small-12 remove-padding\">\r\n            <ul>\r\n              "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"marketingList") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n            </ul>\r\n          </div>\r\n          <div class=\"column show-for-medium-up remove-padding apply-now\">\r\n            "
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"updateApplyNowUrl")||(depth0 && lookupProperty(depth0,"updateApplyNowUrl"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowButtonCardCalc") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"codes") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"abpaEndpoint") : stack1),{"name":"updateApplyNowUrl","hash":{},"data":data,"loc":{"start":{"line":22,"column":20},"end":{"line":22,"column":109}}}),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":12},"end":{"line":23,"column":35}}})) != null ? stack1 : "")
    + "\r\n          </div>\r\n          <div class=\"column small-12 show-for-small-only\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"updateApplyNowUrl")||(depth0 && lookupProperty(depth0,"updateApplyNowUrl"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowButtonCardCalcSmall") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"codes") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"abpaEndpoint") : stack1),{"name":"updateApplyNowUrl","hash":{},"data":data,"loc":{"start":{"line":26,"column":20},"end":{"line":26,"column":114}}}),{"name":"with","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":12},"end":{"line":27,"column":39}}})) != null ? stack1 : "")
    + "\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n  </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"link","hash":{},"data":data,"loc":{"start":{"line":22,"column":112},"end":{"line":23,"column":25}}})) != null ? stack1 : "")
    + " ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"link","hash":{},"data":data,"loc":{"start":{"line":27,"column":12},"end":{"line":27,"column":29}}})) != null ? stack1 : "")
    + " ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":33,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$4 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$4(data, options);
};

const Template$3 = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row\">\r\n    <div class=\"column small-8 no-padding\">\r\n      <h1 class=\"spa-page-title-heading cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</h1>\r\n    </div>\r\n    <div class=\"column small-4 no-padding\">\r\n      <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"show-es-version") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":25,"column":15}}})) != null ? stack1 : "")
    + "      </ul>\r\n    </div>\r\n  </div>\r\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <li class=\"spa-page-header-link\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"locale") : stack1),"==","en_US",{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":12},"end":{"line":16,"column":24}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"locale") : stack1),"==","es_US",{"name":"compare","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":12},"end":{"line":23,"column":24}}})) != null ? stack1 : "")
    + "          </li>\r\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"enEsp") : stack1),{"name":"with","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":14},"end":{"line":15,"column":23}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <a data-redirect=\""
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"hidecard-es-url") : stack1), depth0))
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":12,"column":69},"end":{"line":12,"column":77}}}) : helper)))
    + "\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"es-url") : stack1), depth0))
    + "\">\r\n                  "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"contentEn") || (depth0 != null ? lookupProperty(depth0,"contentEn") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"contentEn","hash":{},"data":data,"loc":{"start":{"line":13,"column":18},"end":{"line":13,"column":33}}}) : helper)))
    + "\r\n                </a>\r\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"enEsp") : stack1),{"name":"with","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":14},"end":{"line":22,"column":23}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <a data-redirect=\""
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"hidecard-en-url") : stack1), depth0))
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":19,"column":69},"end":{"line":19,"column":77}}}) : helper)))
    + "\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"en-url") : stack1), depth0))
    + "\">\r\n                  "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"contentEs") || (depth0 != null ? lookupProperty(depth0,"contentEs") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"contentEs","hash":{},"data":data,"loc":{"start":{"line":20,"column":18},"end":{"line":20,"column":33}}}) : helper)))
    + "\r\n                </a>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":29,"column":7}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate$3 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$3(data, options);
};

const Template$2 = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<section class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"pageID") : stack1), depth0))
    + "\">\r\n  <section class=\"show-for-medium-up row "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"graphContent") : depth0)) != null ? lookupProperty(stack1,"showText") : stack1),"==",true,{"name":"compare","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":10,"column":16}}})) != null ? stack1 : "")
    + "    <div class=\"bar-graphs-rewards-non-preferred col-first column medium-12 large-4\">\r\n\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"graphContent") : depth0)) != null ? lookupProperty(stack1,"showText") : stack1),"==",false,{"name":"compare","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":6},"end":{"line":18,"column":18}}})) != null ? stack1 : "")
    + "\r\n\r\n      <div class=\"row graph-row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"bargraphs") : stack1),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":8},"end":{"line":70,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n\r\n    <div class=\"bar-graphs-rewards-preferred col-second column medium-12 large-7\">\r\n      <div class=\"preferred-opacity show-for-medium-up\">&nbsp;</div>\r\n\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"graphContent") : depth0)) != null ? lookupProperty(stack1,"showText") : stack1),"==",false,{"name":"compare","hash":{},"fn":container.program(18, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":77,"column":6},"end":{"line":91,"column":20}}})) != null ? stack1 : "")
    + "\r\n        <div class=\"row preferred-graphs\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"bargraphs") : stack1),{"name":"each","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":94,"column":10},"end":{"line":133,"column":19}}})) != null ? stack1 : "")
    + "        </div>\r\n\r\n        <div class=\"prlogo\">\r\n          <span class=\"prtext\">\r\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"assisted") : stack1),{"name":"unless","hash":{},"fn":container.program(27, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":138,"column":12},"end":{"line":140,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"assisted") : stack1),{"name":"if","hash":{},"fn":container.program(29, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":141,"column":12},"end":{"line":148,"column":19}}})) != null ? stack1 : "")
    + "          </span>\r\n        </div>\r\n      </div>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"graphContent") : depth0)) != null ? lookupProperty(stack1,"showDisclaimer") : stack1),"==",true,{"name":"compare","hash":{},"fn":container.program(31, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":152,"column":6},"end":{"line":158,"column":18}}})) != null ? stack1 : "")
    + "  </section>\r\n\r\n  <section class=\"calc-row show-for-small-only row "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "\">\r\n\r\n    <div class=\"bar-graphs-rewards bar-graphs-rewards-non-preferred column small-12\">\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"bargraphs") : stack1),{"name":"each","hash":{},"fn":container.program(33, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":165,"column":6},"end":{"line":206,"column":15}}})) != null ? stack1 : "")
    + "    </div>\r\n\r\n    <div class=\"bar-graphs-rewards bar-graphs-rewards-preferred column small-12\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"subline") : stack1),{"name":"if","hash":{},"fn":container.program(39, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":210,"column":6},"end":{"line":218,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"bargraphs") : stack1),{"name":"each","hash":{},"fn":container.program(41, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":219,"column":6},"end":{"line":256,"column":15}}})) != null ? stack1 : "")
    + "\r\n      <div class=\"column small-12 prrow\">\r\n        <span class=\"prtext\">\r\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"assisted") : stack1),{"name":"unless","hash":{},"fn":container.program(48, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":260,"column":10},"end":{"line":262,"column":21}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"assisted") : stack1),{"name":"if","hash":{},"fn":container.program(50, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":263,"column":10},"end":{"line":270,"column":17}}})) != null ? stack1 : "")
    + "        </span>\r\n      </div>\r\n\r\n    </div>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"graphContent") : depth0)) != null ? lookupProperty(stack1,"showDisclaimer") : stack1),"==",true,{"name":"compare","hash":{},"fn":container.program(52, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":275,"column":4},"end":{"line":281,"column":16}}})) != null ? stack1 : "")
    + "  </section>\r\n</section>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"column medium-12 "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + " bar-graphs-header no-padding\">\r\n      <h3>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"headline") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <p>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"headlineDescription") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n    </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"non-pref-header\">\r\n        <h3>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"headline") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n        <h4>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"headlineDescription") : stack1), depth0)) != null ? stack1 : "")
    + "</h4>\r\n      </div>\r\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"preferred") : depth0),"==",false,{"name":"compare","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":8},"end":{"line":69,"column":20}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div\r\n          class=\"column medium-4 large-8 "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"categoryChoiceEnabled")),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":58},"end":{"line":31,"column":178}}})) != null ? stack1 : "")
    + "\" aria-live=\"polite\" aria-describedby=\"barGraphTitle\">\r\n          <div class=\"row\">\r\n            <div class=\"column medium-12\">\r\n              <p class=\"bar-graph-dollar-amount\">$<span class=\"rewards-total\" aria-label=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":90},"end":{"line":34,"column":133}}})) != null ? stack1 : "")
    + "\">0.00</span></p>\r\n            </div>\r\n\r\n            <div class=\"column medium-12\">\r\n              <p class=\"bar-graph-visual-upward\">&nbsp;</p>\r\n            </div>\r\n\r\n            <div class=\"column medium-12\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"camelCase") : depth0),"==",((stack1 = (depths[1] != null ? lookupProperty(depths[1],"graphContent") : depths[1])) != null ? lookupProperty(stack1,"first") : stack1),{"name":"compare","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.program(15, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":42,"column":14},"end":{"line":65,"column":26}}})) != null ? stack1 : "")
    + "            </div>\r\n          </div>\r\n        </div>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isCategoryChoice")),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":98},"end":{"line":31,"column":135}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isUnlimitedCash")),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":135},"end":{"line":31,"column":171}}})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    return "";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"subTag") : depth0), depth0)) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <p class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + " bar-graph-points\">\r\n                <span aria-label=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":34},"end":{"line":44,"column":77}}})) != null ? stack1 : "")
    + "\">0</span> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"unit") : depth0), depth0))
    + "\r\n              </p>\r\n              <p class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + " bar-graph-cash-back\">\r\n                <span aria-label=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":34},"end":{"line":47,"column":77}}})) != null ? stack1 : "")
    + "\">0</span>% "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"unit") : depth0), depth0))
    + "\r\n              </p>\r\n              <p class=\"bar-graph-percentage\">\r\n                <strong>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"tag") : depth0), depth0))
    + "</strong>\r\n              </p>\r\n";
},"15":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <p class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + " bar-graph-points\">\r\n                <span>0</span> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"unit") : depth0), depth0))
    + "\r\n              </p>\r\n              <p class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + " bar-graph-cash-back\">\r\n                <span>0</span>% "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"unit") : depth0), depth0))
    + "\r\n              </p>\r\n              <p class=\"bar-graph-percentage\">\r\n                <strong>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"percentage") : depth0), depth0))
    + "%</strong>\r\n              </p>\r\n              <p class=\"bar-graph-title\">\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":63,"column":16},"end":{"line":63,"column":72}}})) != null ? stack1 : "")
    + "\r\n              </p>\r\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"subTag") : depth0), depth0)) != null ? stack1 : "")
    + "</span>";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"locale") : stack1),"==","es_US",{"name":"compare","hash":{},"fn":container.program(19, data, 0),"inverse":container.program(21, data, 0),"data":data,"loc":{"start":{"line":78,"column":6},"end":{"line":82,"column":22}}})) != null ? stack1 : "")
    + "          <div class=\"rewards-preferred-title row medium-12\">\r\n            <div class=\"spa-icon demo-preferred-rewards\"></div>\r\n            <div class=\"pref-rewards-title-text\">\r\n              <h3>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"subline") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n              <h4>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"sublineDescription") : stack1), depth0)) != null ? stack1 : "")
    + "</h4>\r\n            </div>\r\n          </div>\r\n        </div>\r\n";
},"19":function(container,depth0,helpers,partials,data) {
    return "      <div class=\"is-es\">\r\n";
},"21":function(container,depth0,helpers,partials,data) {
    return "        <div class='rewards-preferred-title-wrapper'>\r\n";
},"23":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"preferred") : depth0),"==",true,{"name":"compare","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":95,"column":10},"end":{"line":132,"column":22}}})) != null ? stack1 : "");
},"24":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"bar-graph column medium-4 "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0)) != null ? stack1 : "")
    + "\" aria-live=\"polite\">\r\n            <div class=\"column medium-12\">\r\n              <p class=\"bar-graph-dollar-amount\">$<span class=\"rewards-total\" aria-label=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":98,"column":90},"end":{"line":98,"column":133}}})) != null ? stack1 : "")
    + "\">0.00</span></p>\r\n            </div>\r\n\r\n            <div class=\"column medium-12\">\r\n              <p class=\"bar-graph-visual-upward\">&nbsp;</p>\r\n            </div>\r\n\r\n            <div class=\"column medium-12\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"camelCase") : depth0),"==",((stack1 = (depths[1] != null ? lookupProperty(depths[1],"graphContent") : depths[1])) != null ? lookupProperty(stack1,"first") : stack1),{"name":"compare","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.program(25, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":106,"column":14},"end":{"line":129,"column":26}}})) != null ? stack1 : "")
    + "            </div>\r\n          </div>\r\n";
},"25":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <p class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + " bar-graph-points\" aria-labelledby=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":117,"column":85},"end":{"line":117,"column":128}}})) != null ? stack1 : "")
    + "\">\r\n                <span>0</span> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"unit") : depth0), depth0))
    + "\r\n              </p>\r\n              <p class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + " bar-graph-cash-back\" aria-labelledby=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":120,"column":88},"end":{"line":120,"column":131}}})) != null ? stack1 : "")
    + "\">\r\n                <span>0</span>% "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"unit") : depth0), depth0))
    + "\r\n              </p>\r\n              <p class=\"bar-graph-percentage\">\r\n                <strong>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"percentage") : depth0), depth0))
    + "%</strong>\r\n              </p>\r\n              <p id=\"barGraphTitle\" class=\"bar-graph-title\">\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":127,"column":16},"end":{"line":127,"column":72}}})) != null ? stack1 : "")
    + "\r\n              </p>\r\n";
},"27":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"preferredFooter") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <p class=\"preferred-rewards-link\">\r\n              "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"pageContent") : depth0)) != null ? lookupProperty(stack1,"learnPreferredRewardsAssisted") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n            </p>\r\n            <p class=\"preferred-rewards-content\">\r\n              "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"pageContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n            </p>\r\n";
},"31":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"column small-12 show-for-medium-up discl-row\">\r\n        <div class=\"discl-text column small-12\">\r\n          <p>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"pageContent") : depth0)) != null ? lookupProperty(stack1,"disclaimer") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n      </div>\r\n";
},"33":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"preferred") : depth0),"==",false,{"name":"compare","hash":{},"fn":container.program(34, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":166,"column":6},"end":{"line":205,"column":18}}})) != null ? stack1 : "");
},"34":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n      <div class=\"bar-graph row "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0)) != null ? stack1 : "")
    + "\">\r\n        <div class=\"column title-content small-12\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"camelCase") : depth0),"==",((stack1 = (depths[1] != null ? lookupProperty(depths[1],"graphContent") : depths[1])) != null ? lookupProperty(stack1,"first") : stack1),{"name":"compare","hash":{},"fn":container.program(35, data, 0, blockParams, depths),"inverse":container.program(37, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":170,"column":10},"end":{"line":182,"column":22}}})) != null ? stack1 : "")
    + "        </div>\r\n        <div class=\"column bar-content small-12 clearfix\">\r\n          <p data-font=\"cnx-regular\" class=\"bar-graph-dollar-amount show-for-medium-up\">$\r\n            <span class=\"rewards-total\" aria-label=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":186,"column":52},"end":{"line":186,"column":95}}})) != null ? stack1 : "")
    + "\">0.00</span>\r\n          </p>\r\n          <p class=\"bar-graph-visual\">&nbsp;</p>\r\n          <p data-font=\"cnx-regular\" class=\"bar-graph-dollar-amount show-for-small-only\">$\r\n            <span class=\"rewards-total\" aria-label=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":190,"column":52},"end":{"line":190,"column":95}}})) != null ? stack1 : "")
    + "\">0.00</span>\r\n          </p>\r\n          <div class=\"bar-graph-points-wrapper clearfix\">\r\n            <p data-font=\"cnx-regular\" class=\"bar-graph-points\">\r\n              <span>0</span> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"unit") : depth0), depth0))
    + "\r\n            </p>\r\n            <p data-font=\"cnx-regular\" class=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0)) != null ? stack1 : "")
    + " bar-graph-cash-back\">\r\n              <span>0</span>% "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"unit") : depth0), depth0))
    + "\r\n            </p>\r\n            <p class=\"sub-tag roboto-regular\"> \r\n              "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"tag") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n";
},"35":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"bar-graph-percentage first\">\r\n            <h2 class=\"title-tag roboto-regular\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"nonPrefTitleTag") : depth0), depth0)) != null ? stack1 : "")
    + "</h2>\r\n            <p class=\"sub-tag roboto-regular\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"nonPrefSubTag") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n          </div>\r\n";
},"37":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <p class=\"bar-graph-percentage\">\r\n            <strong>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"percentage") : depth0), depth0)) != null ? stack1 : "")
    + "%</strong>\r\n          </p>\r\n          <p class=\"bar-graph-title\">\r\n            "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"percentage") : depth0), depth0)) != null ? stack1 : "")
    + "% "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":180,"column":37},"end":{"line":180,"column":93}}})) != null ? stack1 : "")
    + "\r\n          </p>\r\n";
},"39":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"rewards-preferred-title row small-12\">\r\n        <div class=\"spa-icon demo-preferred-rewards\"></div>\r\n        <div class=\"pref-rewards-title-text\">\r\n          <h2 class=\"title-tag roboto-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"subline") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n          <p class=\"sub-tag roboto-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"sublineDescription") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n      </div>\r\n";
},"41":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"preferred") : depth0),"==",true,{"name":"compare","hash":{},"fn":container.program(42, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":220,"column":6},"end":{"line":255,"column":18}}})) != null ? stack1 : "");
},"42":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"bar-graph row "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0)) != null ? stack1 : "")
    + "\">\r\n        <div class=\"column preferred-visual small-12\">\r\n          <div class=\"row\">\r\n            <div class=\"small-4\">\r\n              <p class=\"bar-graph-visual\">&nbsp;</p>\r\n            </div>\r\n            <div class=\"column small-8 bar-graph-points-wrapper clearfix\">\r\n              <p data-font=\"cnx-regular\" class=\"bar-graph-dollar-amount\">$\r\n                <span class=\"rewards-total\">0.00</span>\r\n              </p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"column small-12 remove-padding\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"camelCase") : depth0),"==",((stack1 = (depths[1] != null ? lookupProperty(depths[1],"graphContent") : depths[1])) != null ? lookupProperty(stack1,"first") : stack1),{"name":"compare","hash":{},"fn":container.program(43, data, 0, blockParams, depths),"inverse":container.program(45, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":236,"column":10},"end":{"line":251,"column":22}}})) != null ? stack1 : "")
    + "        </div>\r\n\r\n      </div>\r\n";
},"43":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n          <p class=\"bar-graph-percentage\">\r\n            <strong>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"tag") : depth0), depth0))
    + "</strong>\r\n          </p>\r\n";
},"45":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <p data-font=\"cnx-regular\" class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + " bar-graph-cash-back\">\r\n            <span>0</span>% "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"unit") : depth0), depth0))
    + "\r\n          </p>\r\n          <p data-font=\"cnx-regular\" class=\"bar-graph-points\">\r\n            <span>0</span> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"unit") : depth0), depth0))
    + "\r\n          </p>\r\n          <p class=\"bar-graph-title\">\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subTag") : depth0),{"name":"if","hash":{},"fn":container.program(46, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":249,"column":12},"end":{"line":249,"column":91}}})) != null ? stack1 : "")
    + "\r\n          </p>\r\n";
},"46":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"percentage") : depth0), depth0))
    + "% "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"subTag") : depth0), depth0)) != null ? stack1 : "")
    + "</span>";
},"48":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"graphObj") : depth0)) != null ? lookupProperty(stack1,"preferredFooter") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"50":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <p class=\"preferred-rewards-link\">\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"pageContent") : depth0)) != null ? lookupProperty(stack1,"learnPreferredRewardsAssisted") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </p>\r\n          <p class=\"preferred-rewards-content\">\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"pageContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </p>\r\n";
},"52":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"column small-12 show-for-small-only discl-row\">\r\n      <div class=\"discl-text\">\r\n        <p>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"pageContent") : depth0)) != null ? lookupProperty(stack1,"disclaimer") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n      </div>\r\n    </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"graphObj") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":284,"column":7}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate$2 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"headline row\">\r\n    <div class=\"column medium-12 small-12\">\r\n      <h2 class=\"headline-text\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"headline") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </h2>\r\n    </div>\r\n  </div>\r\n  <div class=\"month-select row\">\r\n    <div class=\"column month-text-container small-12 medium-8 large-9\">\r\n      <h3 class=\"month-selection-text roboto-regular\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"durationText") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </h3>\r\n    </div>\r\n    <div class=\"column small-12 medium-4 large-3\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"durationSelect") : stack1),{"name":"select","hash":{},"data":data,"loc":{"start":{"line":16,"column":6},"end":{"line":16,"column":41}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":19,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sliders") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":43,"column":9}}})) != null ? stack1 : "")
    + "\r\n\r\n<div class=\"row total-value\">\r\n  <div class=\"column small-12 medium-2 text-center show-for-small-only\">\r\n    <span class=\"slider-total-value-wrapper small-only\">\r\n      <strong><span class=\"text-center value\">0</span></strong>\r\n    </span>\r\n  </div>\r\n  <div class=\"column small-12 medium-8 large-10 text-center total-spending\">\r\n    <div class=\"total-spending-wrapper clarfix\">\r\n      <div class=\"total-desc-wrapper\">\r\n        <p class=\"spending-header\">\r\n          <span class='spending-header-text'>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"sliders") : depth0)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"desc") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"sliders") : depth0)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"note") : stack1),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":57,"column":10},"end":{"line":61,"column":17}}})) != null ? stack1 : "")
    + "        </p>\r\n        <p class=\"spending-note\"> "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"sliders") : depth0)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"note") : stack1), depth0)) != null ? stack1 : "")
    + " </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"column small-12 medium-4 large-2 text-center last-col show-for-medium-up\">\r\n    <span class=\"slider-total-value-wrapper medium-up\">\r\n      <strong><span class=\"text-center value\">0</span></strong>\r\n    </span>\r\n  </div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sliders") : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":74,"column":0},"end":{"line":82,"column":9}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"sliders") : depth0)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"note") : stack1),{"name":"if","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":83,"column":0},"end":{"line":89,"column":7}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div>\r\n  <div id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"uniqueID") : depth0), depth0))
    + "\" class=\"slider row\">\r\n    <div class=\"small-12 medium-8 large-8 column\">\r\n      <h4 class=\"slider-tag\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"tag") : depth0), depth0)) != null ? stack1 : "")
    + "</h4>\r\n      <p class=\"slider-desc\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ariaLabel") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":29},"end":{"line":7,"column":76}}})) != null ? stack1 : "")
    + ">\r\n        "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"desc") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subtext") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":14,"column":15}}})) != null ? stack1 : "")
    + "      </p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ariaLabel") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":6},"end":{"line":18,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n    <div class=\"small-12 medium-4 large-4 column slider-control-area\" role=\"application\">\r\n\r\n      <button class=\"slider-minus\" tabindex=\"0\"\r\n        id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"shorthand") : depth0), depth0))
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"content") : depths[1])) != null ? lookupProperty(stack1,"prefix") : stack1)) != null ? lookupProperty(stack1,"minus") : stack1), depth0))
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"camelCase") : stack1), depth0))
    + "\">\r\n                <span class=\"ada-hidden\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"content") : depths[1])) != null ? lookupProperty(stack1,"ADA") : stack1)) != null ? lookupProperty(stack1,"decreasePartOne") : stack1), depth0))
    + " "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"step") : depth0), depth0))
    + "\r\n          "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"content") : depths[1])) != null ? lookupProperty(stack1,"ADA") : stack1)) != null ? lookupProperty(stack1,"partTwo") : stack1), depth0))
    + "</span>\r\n        -\r\n      </button>\r\n\r\n      "
    + ((stack1 = (lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"content") : depths[1])) != null ? lookupProperty(stack1,"barGraphSelect") : stack1),{"name":"select","hash":{},"data":data,"loc":{"start":{"line":30,"column":6},"end":{"line":30,"column":44}}})) != null ? stack1 : "")
    + "\r\n\r\n      <button class=\"slider-plus\" tabindex=\"0\"\r\n        id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"shorthand") : depth0), depth0))
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"content") : depths[1])) != null ? lookupProperty(stack1,"prefix") : stack1)) != null ? lookupProperty(stack1,"plus") : stack1), depth0))
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"page") : depths[1])) != null ? lookupProperty(stack1,"calculator") : stack1)) != null ? lookupProperty(stack1,"camelCase") : stack1), depth0))
    + "\">\r\n                <span class=\"ada-hidden\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"content") : depths[1])) != null ? lookupProperty(stack1,"ADA") : stack1)) != null ? lookupProperty(stack1,"increasePartOne") : stack1), depth0))
    + " "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"step") : depth0), depth0))
    + "\r\n          "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"content") : depths[1])) != null ? lookupProperty(stack1,"ADA") : stack1)) != null ? lookupProperty(stack1,"partTwo") : stack1), depth0))
    + "</span>\r\n        +\r\n      </button>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "aria-hidden=\"true\"";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <a id=\"calcTooltipCta"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":10,"column":29},"end":{"line":10,"column":39}}}) : helper)))
    + "\" href=\"javascript:void(0);\"\r\n          class=\"icon-link spa-ui-layer-link spa-fn spa-ui-layer-tooltip-link\" rel=\"calcTooltip"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":11,"column":95},"end":{"line":11,"column":105}}}) : helper)))
    + "\"\r\n          data-options='{\"layerType\":\"tooltip\",\"rel\":\"calcTooltip"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":12,"column":65},"end":{"line":12,"column":75}}}) : helper)))
    + "\"},\"maxHeight\":\"280\",\"maxWidth\":\"400\"'></a>\r\n          <span class=\"slider-desc-subtext roboto-regular\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"subtext") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"ada-hidden\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"ariaLabel") : depth0), depth0))
    + "</span>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <a id=\"spendingNoteTooltipCta"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":58,"column":39},"end":{"line":58,"column":49}}}) : helper)))
    + "\" href=\"javascript:void(0);\"\r\n            class=\"icon-link spa-ui-layer-link spa-fn spa-ui-layer-tooltip-link\" rel=\"spendingNoteTooltip"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":59,"column":105},"end":{"line":59,"column":115}}}) : helper)))
    + "\"\r\n            data-options='{\"layerType\":\"tooltip\",\"rel\":\"spendingNoteTooltip"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":60,"column":75},"end":{"line":60,"column":85}}}) : helper)))
    + "\"},\"maxHeight\":\"280\",\"maxWidth\":\"400\"'></a>\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subtext") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":75,"column":0},"end":{"line":81,"column":7}}})) != null ? stack1 : "");
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"calcTooltip"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":76,"column":20},"end":{"line":76,"column":30}}}) : helper)))
    + "\" class=\"hide\" data-options='{\"type\":\"info\"}'>\r\n  <p class=\"content\">\r\n    "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"subtext") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n  </p>\r\n</div>\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"spendingNoteTooltip"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":84,"column":28},"end":{"line":84,"column":38}}}) : helper)))
    + "\" class=\"hide\" data-options='{\"type\":\"info\"}'>\r\n  <p class=\"content\">\r\n    "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"sliders") : depth0)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"note") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n  </p>\r\n</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sliders") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":90,"column":7}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/rewards-calc-cc-module",
  "version": "7.0.9",
  "id": "rewardsCalcCcModule",
  "containerID": "creditCardsRewardsCalcCcModule",
  "moduleName": "credit-cards-rewards-calc-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "rewards-calc-cc-module",
  "data": {
    "init": "rewardsCalcCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "hideTotal",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter shows/hides the total value row beneath calculator sliders."
  }, {
    "name": "showCardForCalc",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter should be set to show/hide the card content for standalone calculator pages."
  }, {
    "name": "showEngagementSection",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter should be set to show/hide the engagement navbar above the calculator on standalone pages."
  }, {
    "name": "sliderSortOrder",
    "type": "string",
    "values": ["ASC", "DSC"],
    "default": "DSC",
    "description": "This parameter should be set to the change default sort order for sliders."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$5(context, {
      "helpers": {
        compare,
        select,
        link,
        json,
        htmlEscaper,
        updateApplyNowUrl
      },
      "partials": {
        "rewards-calc-card-display-partial": renderTemplate$4,
        "rewards-calc-engagement-partial": renderTemplate$3,
        "rewards-calc-graphs-partial": renderTemplate$2,
        "rewards-calc-headline-partial": renderTemplate$1,
        "rewards-calc-slider-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$5,
  "partials": {
    "rewards-calc-card-display-partial": renderTemplate$4,
    "rewards-calc-engagement-partial": renderTemplate$3,
    "rewards-calc-graphs-partial": renderTemplate$2,
    "rewards-calc-headline-partial": renderTemplate$1,
    "rewards-calc-slider-partial": renderTemplate
  },
  "helpers": {
    compare,
    select,
    link,
    json,
    htmlEscaper,
    updateApplyNowUrl
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/calculator-math-utility": "^1.0.0",
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

let hasModuleInit = false;

/* eslint-disable require-jsdoc */
/**
 * Implementation of the rewards-calc-cc-module module.
 * @copyright 2017-12-15
 * @since 12/15/2017, 3:16:31 PM
 * @file
 */

/* global spaParams */
/* eslint-disable no-param-reassign, max-len */

/**
 * The RewardsCalcCcModule Sparta Module.
 * calculator module for cash rewards pages
 * @export
 * @class
 */

const PERCENT_DENOMINATOR = 100;
class rewardsCalcCcModuleJS extends Module {
  /**
   * Creates an instance of RewardsCalcCcModule.
   * @memberof RewardsCalcCcModule
   * @param {Object} options - constructor options
   * @param {Object} context - constructor context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.MathFuncs = calculatorMathUtility.math;
    const {
      target
    } = this.settings;
    const constants = {
      bargraphs: {
        NON_CUST: 'NON_CUST_',
        CUST: 'CUST_',
        GOLD_CUST: 'GOLD_CUST_',
        PLAT_CUST: 'PLATINUM_CUST_',
        PLAT_HONOR_CUST: 'PLATINUM_HONOR_CUST_'
      },
      bargraphClassnames: {
        NON_CUST: '',
        CUST: '',
        GOLD_CUST: '',
        PLAT_CUST: '',
        PLAT_HONOR_CUST: ''
      },
      strings: {
        GRAPH_TAG: 'GRAPH_TAG',
        GRAPH_COLOR: 'GRAPH_COLOR',
        HEADLINE_TERM: 'HEADLINE_TERM',
        CALC_TOTAL_NOTE: 'CALC_TOTAL_NOTE_',
        CALC_TOTAL_DESC: 'CALC_TOTAL_DESC_',
        GRAPH_SUB_TAG: 'GRAPH_SUB_TAG',
        PRECENTAGE_BONUS: 'PRECENTAGE_BONUS',
        MON: 'MON',
        TAG: '_TAG',
        MAX: '_MAX_',
        CALC: 'CALC_',
        DESC: '_DESC',
        SUBTEXT: '_SUBTEXT',
        BIND: '_BIND_',
        MONTHS: ' months',
        ONE_YEAR: '1 year',
        PERCT: '_PERCENTAGE_',
        PREFERRED: 'Preferred',
        PREFERRED_SLIDER: 'PercentageSlider',
        BONUS: 'bonus',
        PERCTSIGN: '%',
        SHORT_DESC: '_SHORT_DESC',
        CALC_ENABLE: 'CALC_ENABLE_',
        MARKETING_BULLET_LIST: 'CARD_PRODUCT_DETAILS_CONTENT_'
      },
      onLoad: {
        TIMESPAN: false
      }
    };
    Object.assign(this.settings, constants);
    this.engagementSection = target.querySelector('.engagement-section');
    this.headlineSection = target.querySelector('.headline-section');
    this.sliderSection = target.querySelector('.slider-section');
    this.sliders = [];
    this.barGraphsSection = target.querySelector('.bargraphs-section');
    this.barGraphs = {
      bargraphs: []
    };
    this.cardDisplaySection = target.querySelector('.card-display-section');
    this.cardInfo = {};
    this.current = {}; //
    this.last = {}; // Needed for variable rewards calculations.
    this.sliderUpdate = {}; //

    this.engagementTemplatePartial = _moduleConfig.partials['rewards-calc-engagement-partial'];
    this.headlineTemplatePartial = _moduleConfig.partials['rewards-calc-headline-partial'];
    this.slidersTemplatePartial = _moduleConfig.partials['rewards-calc-slider-partial'];
    this.bargraphsTemplatePartial = _moduleConfig.partials['rewards-calc-graphs-partial'];
    this.cardDisplayPartial = _moduleConfig.partials['rewards-calc-card-display-partial'];
    this.content = JSON.parse(target.querySelector('#rewards-calc-default').dataset.jcr);
    // This can be removed if the translations team stops sending us encoded html entities
    this.textarea = document.createElement('textarea');
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {void}
   * @see isCategoryChoice - Checks to see if current campaign is part of the Olive project.
   */
  init() {
    if (!hasModuleInit) {
      hasModuleInit = true;
      if (spaParams.pageParams.calculator.timespan) {
        this.settings.onLoad.TIMESPAN = spaParams.pageParams.calculator.timespan;
      }
      this.Events.sub('campaignProperties-spartaStore', data => {
        this.settings.target.querySelector('.top-container').classList.remove('hidden');
        this.campaignProperties = data.data.data;
        const campaign = this.Store.getData('campaign');
        const content = creditCardUtility.generateLinkContent(this.content, this.campaignProperties);
        const graphContent = this.getGraphContent();
        const isCategoryChoice = !!(this.campaignProperties.CALC_CUST_GRAPH_TAG && this.campaignProperties.CALC_CUST_GRAPH_TAG.toLowerCase() === 'choice');
        const isUnlimitedCash = !!(this.campaignProperties.CALC_CUST_GRAPH_TAG && this.campaignProperties.CALC_CUST_GRAPH_TAG.toLowerCase() === 'unlimited');
        graphContent.showDisclaimer = graphContent.showDisclaimer && !this.params.showEngagementSection;

        // Build the slider & bargraph objects using default timespan
        this.buildSliderObjects(spaParams.pageParams.calculator.timespan);
        this.buildBarGraphs();

        // Render headline, slider, and graph partials
        const renderedTemplate = this.headlineTemplatePartial({
          campaignProperties: this.campaignProperties,
          campaign,
          content
        });
        const renderedSliders = this.slidersTemplatePartial({
          sliders: this.sliders,
          page: spaParams.pageParams,
          content
        });
        const renderedGraphs = this.bargraphsTemplatePartial({
          graphObj: this.barGraphs,
          page: spaParams.pageParams,
          site: spaParams.siteParams,
          pageContent: content,
          graphContent,
          campaign,
          isCategoryChoice,
          isUnlimitedCash
        });
        this.headlineSection.innerHTML = renderedTemplate;
        this.sliderSection.innerHTML = renderedSliders;
        this.barGraphsSection.innerHTML = renderedGraphs;
        if (this.settings.onLoad.TIMESPAN) {
          this.headlineSection.querySelector('#durationSelect').value = this.settings.onLoad.TIMESPAN;
        }

        // Display card info section if enabled for page
        if (this.params.showCardForCalc) {
          // Check for url hide override
          const hideCard = this.SpartaFunctions.getUrlParam('hidecard');
          if (!hideCard) {
            this.buildCardForCalcInfo(campaign);
            const renderedCardDisplay = this.cardDisplayPartial({
              cardInfo: this.cardInfo,
              site: spaParams.siteParams,
              content
            });
            this.cardDisplaySection.innerHTML = renderedCardDisplay;
            this.initShowHideDetails();
          }
        }

        // Display engagement section if enabled for page
        if (this.params.showEngagementSection) {
          // Render template
          const renderedEngagementSection = this.engagementTemplatePartial({
            page: spaParams.pageParams,
            content,
            campaignProperties: this.campaignProperties,
            campaign
          });
          this.engagementSection.innerHTML = renderedEngagementSection;
          this.pageUrlAppend();
        }

        // Hide total value area if enabled
        if (this.params.hideTotal) {
          const totalValueRow = this.sliderSection.querySelector('.row .total-value');
          totalValueRow.style.display = 'none';
        }

        // Bind event handlers
        this.bindEvents();

        // Initialize sliders with noUiSlider
        this.sliders.forEach(slider => {
          this.initSlider(slider);
        });
        this.updateAria();
        this.updateSpanishDollarLabels();
        this.Events.pub(creditCardUtility.EVENTS.productDetailsRendered, {
          module: this.settings.moduleInfo.name
        });
      });
    }
  }

  /**
   * Makes necessary aria tweaks that can't be done via JCR
   * @returns {void}
   */
  updateAria() {
    const amountSpentSelect = document.getElementById('amountSpentSelect');
    [...amountSpentSelect.querySelectorAll('option')].forEach(option => {
      option.setAttribute('aria-live', 'assertive');
    });
  }

  /**
   * Returns the JCR data for graphing specific to this calculator
   * @returns {void}
   */
  getGraphContent() {
    return this.content.productSpecificSections[spaParams.pageParams.calculator.id];
  }

  /**
   * Bind event handlers to their respective events.
   * @returns {void}
   */
  bindEvents() {
    const {
      target
    } = this.settings;
    // Bind handler for changing timespan
    this.durationSel = target.querySelector('#durationSelect');
    this.durationSel.onchange = this.durationSelectionChanged.bind(this);
    creditCardUtility.delegateEvents('click', '.slider-plus, .slider-minus', this.incrementDecrement.bind(this), false, target);
  }

  /**
   * Builds the this.sliders array for the page from PCM response
   * @param {Number} timespan - Number of months to calculate rewards for
   * @returns {void}
   */
  buildSliderObjects(timespan) {
    // Get the sliders for this campaign
    Object.keys(this.campaignProperties).forEach(this.getSlidersFromKeys.bind(this));
    // Map those sliders' properties
    this.sliders = this.sliders.map(this.mapSliderProps.bind(this, timespan));
    // Sort order for displaying sliders on the page
    if (this.params.sliderSortOrder === 'DSC') {
      this.sliders = this.sliders.sort(rewardsCalcCcModuleJS.sortDesc);
    } else {
      this.sliders = this.sliders.sort(rewardsCalcCcModuleJS.sortAsc);
    }
  }

  /**
   * Builds the this.barGraphs object containing properties from PCM
   * @returns {void}
   */
  buildBarGraphs() {
    // Get the bargraphs for this campaign and map their properties from PCM
    Object.keys(this.settings.bargraphs).forEach(this.mapBarGraphProps.bind(this));
    this.barGraphs.type = this.campaignProperties.CALC_EARN_TYPE;
    this.barGraphs.headline = this.campaignProperties.CALC_BASIC_REWARDS_GRAPH_HEADLINE;
    this.barGraphs.headlineDescription = this.campaignProperties.CALC_BASIC_REWARDS_GRAPH_SUBHEADLINE;
    if (['cash back', 'reembolso de dinero'].indexOf(this.barGraphs.type) !== -1) {
      this.barGraphs.subline = this.campaignProperties.CALC_PREFERRED_REWARDS_GRAPH_HEADLINE;
      this.barGraphs.sublineDescription = this.campaignProperties.CALC_PREFERRED_REWARDS_GRAPH_SUBHEADLINE;
    }
    this.barGraphs.strip = this.campaignProperties.CALC_PREFERRED_REWARDS_GRAPH_HEADLINE_SMALL;
    this.barGraphs.preferredFooter = this.campaignProperties.CALC_PREFERRED_REWARDS_GRAPH_FOOTER;
  }

  /**
   * Builds the this.cardInfo object for displaying card details on standalone calc pages
   * @param {Object} campaign - The page's campaign in PCM
   * @returns {void}
   */
  buildCardForCalcInfo(campaign) {
    const {
      campaignID,
      locale,
      poCode
    } = campaign;
    // Need to doctor a link in the response from PCM, do it here.
    let marketingList = this.campaignProperties.MARKETING_BULLET_LIST_RESEARCH;
    marketingList = marketingList.replace('headlineCcalcModule', 'rewardsCalcCcModule');
    this.cardInfo = {
      title: this.campaignProperties.MARKETING_PRODUCT_NAME_LONG,
      marketingList,
      image: this.campaignProperties.APPLICATION_DISPLAY_HEADER_CARD_Image_URL,
      codes: {
        title: this.campaignProperties.MARKETING_PRODUCT_NAME_LONG,
        locale,
        campaignID,
        poCode,
        group: this.campaignProperties.GROUP_CODE
      }
    };
  }

  /**
   * Maps the slider keys from PCM for this campaign.
   * @param {String} key - PCM property representing a slider.
   * @returns {void}
   */
  getSlidersFromKeys(key) {
    if (key.includes('_SHORT_DESC') && this.campaignProperties[key]) {
      // This is a slider and it should be built.
      if (this.campaignProperties[key] === 'gasolina') {
        // Map spanish key back to english for code clarity purposes
        this.campaignProperties[key] = 'gas';
      }
      if (this.campaignProperties[key] === 'comestibles') {
        // Map spanish key back to english for code clarity purposes
        this.campaignProperties[key] = 'grocery';
      }
      if (this.campaignProperties[key] === 'en todo momento') {
        // Map spanish key back to english for code clarity purposes
        this.campaignProperties[key] = 'everytime';
      }

      // Push mapped slider base object into this.sliders
      this.sliders.push({
        lowercase: this.campaignProperties[key],
        uppercase: this.campaignProperties[key].toUpperCase()
      });
    }
  }

  /**
   * Function passed into mapping operation for sliders. Assigns properties from PCM to slider object
   * @param {Number} timespan - Number of months for calculating rewards
   * @param {Object} slider - The slider object being mapped
   * @returns {Object} temp - The temp object with mapped slider properties, to be assigned back into the slider object
   */
  mapSliderProps(timespan, slider) {
    const temp = {};
    const {
      strings
    } = this.settings;

    // If a timespan is passed, use it.. else use default from settings (false)
    temp.timespan = timespan || this.settings.onLoad.TIMESPAN;
    const tag = `${strings.CALC}${slider.uppercase}${strings.TAG}`;
    temp.tag = this.campaignProperties[tag];
    const desc = `${strings.CALC}${slider.uppercase}${strings.DESC}`;
    temp.desc = this.campaignProperties[desc];
    const currencyRegex = /\$\d+(\.\d+)?/g;
    if (this.spaParams.language === 'es' && temp.desc.includes('$')) {
      const amount = temp.desc.match(currencyRegex);
      if (amount && amount.length > 0) {
        temp.ariaLabel = this.spanishDollarLabel(amount[0], temp.desc);
      }
    }
    const subtext = `${strings.CALC}${slider.uppercase}${strings.DESC}${strings.SUBTEXT}`;
    temp.subtext = this.campaignProperties[subtext];
    const bind = `${strings.CALC}${slider.uppercase}${strings.BIND}${temp.timespan}${strings.MON}`;
    temp.bind = parseInt(this.campaignProperties[this.campaignProperties[bind]], 10);
    temp.bind = Number.isNaN(temp.bind) ? false : temp.bind;
    const max = `${strings.CALC}${slider.uppercase}${strings.MAX}${temp.timespan}${strings.MON}`;
    temp.max = parseInt(this.campaignProperties[max], 10);
    const percentage = `${strings.CALC}${slider.uppercase}${strings.PERCT}${temp.timespan}${strings.MON}`;
    temp.percentage = parseFloat(this.campaignProperties[percentage]);
    temp.lowercase = slider.lowercase;
    temp.uppercase = slider.uppercase;
    temp.shorthand = slider.lowercase;
    temp.step = 100;
    temp.uniqueID = `${temp.lowercase}${temp.percentage}${strings.PREFERRED_SLIDER}`;
    temp.uniqueID = temp.uniqueID.replace('.', '-');

    // populate content
    temp.content = {
      shorthand: temp.shorthand,
      percentage: temp.percentage,
      timespan: parseInt(temp.timespan, 10),
      desc: this.campaignProperties[`${strings.CALC_TOTAL_DESC}${parseInt(temp.timespan, 10)}${strings.MON}`],
      note: this.campaignProperties[`${strings.CALC_TOTAL_NOTE}${parseInt(temp.timespan, 10)}${strings.MON}`],
      step: this.step
    };
    if (temp.bind) {
      // Set initial limit props for later use
      temp.amountBeforeLimit = 0;
      temp.amountOverLimit = 0;
    }
    return temp;
  }

  /**
   * Pushes/Maps properties from PCM campaign to bargraph object.
   * @param {String} key - string representing what graph is being mapped.
   * @returns {void}
   */
  mapBarGraphProps(key) {
    const temp = {};
    const {
      bargraphs,
      bargraphClassnames,
      strings
    } = this.settings;
    temp.preferred = false;
    const color = `${strings.CALC}${bargraphs[key]}${strings.GRAPH_COLOR}`;
    temp.color = this.campaignProperties[color];
    const tag = `${strings.CALC}${bargraphs[key]}${strings.GRAPH_TAG}`;
    temp.tag = this.campaignProperties[tag] ? this.campaignProperties[tag] : '';
    temp.class = rewardsCalcCcModuleJS.stringToSnakeCase(temp.tag);
    temp.camelCase = rewardsCalcCcModuleJS.stringToCamelCase(temp.tag);
    const subTag = `${strings.CALC}${bargraphs[key]}${strings.GRAPH_SUB_TAG}`;
    temp.subTag = this.campaignProperties[subTag];
    if (temp.class === 'cash-back-rewards') {
      temp.nonPrefTitleTag = this.campaignProperties.CALC_BASIC_REWARDS_GRAPH_HEADLINE;
      temp.nonPrefSubTag = this.campaignProperties.CALC_BASIC_REWARDS_GRAPH_SUBHEADLINE_SMALL;
    }
    if (temp.tag.toLowerCase() === 'choice' || temp.tag.toLowerCase() === 'unlimited') {
      temp.class = 'hidden';
    }
    if (temp.subTag === undefined) {
      temp.subTag = false;
    }
    if (temp.subTag && temp.subTag.includes(strings.PREFERRED)) {
      temp.preferred = true;
    }
    if (temp.class.includes(strings.PERCTSIGN)) {
      temp.class = rewardsCalcCcModuleJS.stringToSnakeCase(temp.subTag);
      temp.camelCase = rewardsCalcCcModuleJS.stringToCamelCase(temp.subTag);
    }
    const percentage = `${strings.CALC}${bargraphs[key]}${strings.PRECENTAGE_BONUS}`;
    temp.percentage = parseInt(this.campaignProperties[percentage], 10);
    temp.unit = this.campaignProperties.CALC_BAR_GRAPH_UNIT;
    if (this.hasHTMLEntities(temp.class)) {
      temp.class = this.decodeHTMLEntities(temp.class);
    }
    this.barGraphs.bargraphs.push(temp);
    bargraphClassnames[key] = `.${temp.class}`;
  }

  /**
   * Adds aria labels to dollar amounts when the page is in Spanish
   * @returns {void}
   */
  updateSpanishDollarLabels() {
    if (this.spaParams.language !== 'es') {
      return;
    }
    const totalRewards = [...document.querySelectorAll('.bar-graph-dollar-amount')];
    totalRewards.filter(totalReward => totalReward.offsetParent).forEach(totalReward => {
      // Filter out all hidden elements (yet another page with repeated dom for different screen sizes)
      totalReward.setAttribute('aria-hidden', true);
      let adaEle = totalReward.parentElement.querySelector('.rewards-total-spanish');
      if (!adaEle) {
        adaEle = document.createElement('p');
        adaEle.classList.add('ada-hidden');
        adaEle.classList.add('rewards-total-spanish');
        totalReward.parentElement.appendChild(adaEle);
      }
      adaEle.innerHTML = this.spanishDollarLabel(totalReward.innerText, totalReward.innerText);
    });
  }

  /**
   * @param {string} amount - $$ value
   * @param {string} label - label with $$ amount
   * @returns {string} label - updated label
   */
  spanishDollarLabel(amount = '$0', label = '') {
    const cleanedAmount = amount.replace('$', '').replace('0.00', '0');
    return label.replace(amount, `${cleanedAmount} ${this.dolarOrDolares(cleanedAmount)}`);
  }

  /**
   * Determines if a $$ amount should be singular or plural
   * @param {Object} amount - numeric value
   * @returns {string} dolares
   */
  dolarOrDolares(amount = 0) {
    return parseFloat(amount, 10) === 1 ? 'dólar' : 'dólares';
  }

  /**
   * Initializes the noUiSlider for each slider object. Instantiates binds and sets update handler
   * @param {OBject} slider - slider object to be initialized
   * @returns {void}
   */
  initSlider(slider) {
    // Instantiate the slider div as a noUiSlider
    const selectRow = this.sliderSection.querySelector(`#${slider.uniqueID}`);
    const selectContainer = selectRow.querySelector('.slider-value-wrapper');
    const plusButton = selectRow.querySelector('.slider-plus');
    const minusButton = selectRow.querySelector('.slider-minus');
    selectContainer.setAttribute('value', 0);

    // Reset slider to only have $0 value
    selectContainer.options.length = 1;
    selectContainer.options[0].value = 0;
    selectContainer.options[0].innerHTML = '$0';
    // Generate object of options for this slider
    const sliderSelectOptions = rewardsCalcCcModuleJS.buildSliderIncrements(slider.max);

    // Change the step increments from 100 to 1000 for elite card or 1M max or more
    if (slider.max >= 1000000) {
      slider.step = 1000;
    }

    // Loop and add options to the select
    Object.keys(sliderSelectOptions).forEach(value => {
      const newOption = new Option(sliderSelectOptions[value], value);

      // fix for JAWS reading '$' as 'pesos'
      if (this.spaParams.language === 'es') {
        selectContainer.options[0].setAttribute('aria-label', '0 dólares');
        newOption.setAttribute('aria-label', `${value} ${this.dolarOrDolares(value)}`);
      }
      selectContainer.options[selectContainer.options.length] = newOption;
    });
    selectContainer.onchange = this.sliderSelectChanged.bind(this);

    // Set slider update handler
    selectContainer.addEventListener('change', () => {
      this.Events.pub(creditCardUtility.EVENTS.valueChange);
    });
    this.Events.sub(creditCardUtility.EVENTS.valueChange, () => {
      this.updateSliders(slider);
      this.updateBarGraphs();
    });

    // set ADA attributes
    selectContainer.setAttribute('aria-label', `${slider.tag} dropdown value`);
    if (plusButton && minusButton) {
      plusButton.setAttribute('aria-valuemax', `$${rewardsCalcCcModuleJS.commaSeparateNumber(slider.max)}`);
      minusButton.setAttribute('aria-valuemin', '$0');
      minusButton.setAttribute('aria-valuenow', '$0');

      // Update step increments
      plusButton.dataset.step = slider.step;
      minusButton.dataset.step = slider.step;
    }
  }

  /**
   * Updates the noUiSlider's range when changing slider timespan
   * @param {Object} slider - Slider object to update
   * @param {Number} min - Minimum range
   * @param {Number} max - Maximum range
   * @returns {void}
   */
  updateSliderRange(slider, min, max) {
    // Instantiate the slider div as a noUiSlider
    const sliderRow = this.sliderSection.querySelector(`#${slider.uniqueID}`);
    const sliderInput = sliderRow.querySelector('.value');
    const plusButton = sliderRow.querySelector('.slider-plus');
    plusButton.setAttribute('aria-valuemax', `$${max}`);

    // Reset slider to only have $0 value
    sliderInput.options.length = 1;
    sliderInput.options[0].value = 0;
    sliderInput.options[0].innerHTML = '$0';
    // Generate object of options for this slider
    const sliderSelectOptions = rewardsCalcCcModuleJS.buildSliderIncrements(max);
    // Loop and add options to the select
    Object.keys(sliderSelectOptions).forEach(value => {
      sliderInput.options[sliderInput.options.length] = new Option(sliderSelectOptions[value], value);
    });
  }

  /**
   * Update slider values and set current and last sliders.
   * @param {Object} lastSelected - Last selected slider
   * @returns {void}
   */
  updateSliders(lastSelected) {
    this.sliders.map(slider => {
      const sliderRow = this.sliderSection.querySelector(`#${slider.uniqueID}`);
      // const sliderEl = sliderRow.querySelector(`#${slider.lowercase}Slider`);
      const elValueContainer = sliderRow.querySelector('.value');
      let value;
      if (elValueContainer && elValueContainer.value !== '') {
        value = elValueContainer.value;
      } else {
        value = 0;
      }
      slider.curValue = parseInt(value, 10);

      // assign current vs last selected slider
      if (lastSelected.shorthand === slider.shorthand && slider.bind) {
        this.current = slider;
      } else if (slider.bind && lastSelected.shorthand !== slider.shorthand) {
        this.last = slider;
      }
      return slider;
    });
    if (lastSelected.bind) {
      this.updateSliderLimits();
    }
  }

  /**
   * Performs calculations to determine rewards for sliders that have limited cash back.
   * @returns {void}
   */
  updateSliderLimits() {
    // Get last and current updated sliders
    const {
      last,
      current
    } = this;
    const max = current.bind;
    const sum = last.curValue + current.curValue;
    // Determine if the sum of bounded sliders is less than the total limit
    const lessThanMax = sum <= max;
    this.onePercent = !lessThanMax;

    // Limit has not been met, perform normal calculations
    if (!this.onePercent) {
      current.amountBeforeLimit = current.curValue;
      last.amountBeforeLimit = last.curValue;
      if (current.curValue < current.amountBeforeLimit && current.curValue < max) {
        current.amountBeforeLimit = current.curValue;
        last.amountBeforeLimit = max - current.amountBeforeLimit;
      }
      this.onePercent = false;
    } else {
      // Limit has been met or exceeded, determine amounts before and after the limit for rewards calculations
      if (current.curValue < current.amountBeforeLimit && current.curValue < max) {
        current.amountBeforeLimit = current.curValue;
        last.amountBeforeLimit = max - current.amountBeforeLimit; // Amount before reaching limit on previously updated slider must be the maximum minus the current amount.
      } else {
        current.amountBeforeLimit = max - last.amountBeforeLimit; // Amount before reaching limit on currently updated slider must be the maximum minus the last amount.
      }
      this.onePercent = true;
    }
    current.amountOverLimit = current.curValue - current.amountBeforeLimit;
    last.amountOverLimit = last.curValue - last.amountBeforeLimit;
    if (current.amountOverLimit < 0) {
      current.amountBeforeLimit = current.amountOverLimit + current.amountBeforeLimit;
      last.amountBeforeLimit = max - current.amountBeforeLimit;

      // Handle the fact that our sliders increment in steps of 100, so need to equalize.
      if (last.amountOverLimit - Math.abs(current.amountOverLimit) === 100 || current.amountOverLimit - Math.abs(last.amountOverLimit) === 100) {
        current.amountOverLimit = 100;
        last.amountBeforeLimit = last.amountOverLimit;
        current.amountBeforeLimit -= 100;
        last.amountOverLimit = 0;
      }
    }
    // Cache the sliders that were updated for use in bargraphs.
    this.sliderUpdate = {
      last: this.last,
      current: this.current
    };
  }

  /**
   * Calculate the rewards genereted based on slider values and percentages.
   * Update the spans on bounded sliders to reflect amount being applied at full rewards percentage.
   * Update total of all sliders.
   * @returns {void}
   */
  updateBarGraphs() {
    // Initialize variables
    let values = 0;
    const valuesObj = {};
    let max = 0;
    let rewards = 0;

    // Iterate over each slider and calculate rewards
    this.sliders.forEach(slider => {
      const sliderRow = this.sliderSection.querySelector(`#${slider.uniqueID}`);
      const elValueContainer = sliderRow.querySelector('.value');
      max += slider.max * 2 / PERCENT_DENOMINATOR;

      // Get initial rewards value before limits are applied.
      slider.rewards = slider.curValue * slider.percentage / PERCENT_DENOMINATOR;

      // Handle rewards calculations for bounded sliders.
      Object.keys(this.sliderUpdate).forEach(updated => {
        if (this.sliderUpdate[updated].shorthand === slider.shorthand) {
          slider.rewards = this.sliderUpdate[updated].amountBeforeLimit * slider.percentage / PERCENT_DENOMINATOR + this.sliderUpdate[updated].amountOverLimit * 1 / PERCENT_DENOMINATOR;

          // Determine the width of the reward-limit span
          const width = this.sliderUpdate[updated].amountBeforeLimit / slider.max * PERCENT_DENOMINATOR;
          const limitSpan = elValueContainer.querySelector('.reward-limit');
          if (limitSpan) {
            limitSpan.style.width = `${width}%`;
          }
        }
      });

      // Add to overall values
      rewards += slider.rewards;
      values += slider.curValue;
      valuesObj[slider.percentage] = slider.curValue;
    });

    // Perform calculations necessary to update the graph objects
    const smallscreen = spartaMediaQueryUtility.getCurrentViewport().currentViewport.includes('small');
    this.performGraphCalculations(values, valuesObj, max, rewards);
    let sliderTotalValWrapper;
    if (smallscreen) {
      sliderTotalValWrapper = this.sliderSection.querySelector('.small-only'); // grabs slider-total-value-wrapper for small
    } else {
      sliderTotalValWrapper = this.sliderSection.querySelector('.medium-up'); // grabs slider-total-value-wrapper for med up
    }
    sliderTotalValWrapper.querySelector('.value').innerHTML = `$${rewardsCalcCcModuleJS.commaSeparateNumber(values)}`;
    this.updateSpanishDollarLabels();
  }

  /**
   * @param {String} input - string to decode
   * @returns {Boolean} hasEntities
   */
  hasHTMLEntities(input = '') {
    const regex = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/;
    return input.match(regex);
  }

  /**
   * @param {String} input - string to decode
   * @returns {String} decoded
   */
  decodeHTMLEntities(input = '') {
    // We will reuse the textarea to avoid creating multiple unattached DOM elements
    this.textarea.innerHTML = input;
    return this.textarea.value;
  }

  /**
   * Calculations to determine the size and value of the various rewards bar graphs.
   * Uses the MathFuncs utility functions to determine values.
   * @param {Number} values - Total of all sliders
   * @param {Object} valuesObj - Object containing slider specific values
   * @param {Number} max - Maximum rewards
   * @param {Number} rewards - Total of all earned rewards
   * @returns {void}
   */
  performGraphCalculations(values, valuesObj, max, rewards) {
    this.barGraphCalculations = {
      // Cash Back Graph
      cashBackRewards: this.MathFuncs.rewards(rewards, 1),
      cashBackRewardsPercentage: this.MathFuncs.percentages(rewards, values, 1),
      cashBackRewardsBarGraph: 3 + this.MathFuncs.barGraphHeight(rewards, max, 0.8),
      cashBackRewardsBarGraphMobile: 3 + this.MathFuncs.barGraphHeight(rewards, max, 0.1),
      cashBackRewardsTravel: this.MathFuncs.travel(valuesObj, 1),
      // Customer Bonus Graph
      checkCustomerBonus: this.MathFuncs.rewards(rewards, 1.1),
      checkCustomerBonusPercentage: this.MathFuncs.percentages(rewards, values, 1.1),
      checkCustomerBonusBarGraph: 3 + this.MathFuncs.barGraphHeight(rewards, max, 1.6),
      checkCustomerBonusBarGraphMobile: 3 + this.MathFuncs.barGraphHeight(rewards, max, 0.3),
      checkCustomerBonusTravel: this.MathFuncs.travel(valuesObj, 1.1),
      // Preferred Rewards Gold Graph
      goldPreferredRewards: this.MathFuncs.rewards(rewards, 1.25),
      goldPreferredRewardsPercentage: this.MathFuncs.percentages(rewards, values, 1.25),
      goldPreferredRewardsBarGraph: 3 + this.MathFuncs.barGraphHeight(rewards, max, 2.2),
      goldPreferredRewardsBarGraphMobile: 3 + this.MathFuncs.barGraphHeight(rewards, max, 0.5),
      goldPreferredRewardsTravel: this.MathFuncs.travel(valuesObj, 1.25),
      // Preferred Rewards Platinum Graph
      platinumPreferredRewards: this.MathFuncs.rewards(rewards, 1.50),
      platinumPreferredRewardsPercentage: this.MathFuncs.percentages(rewards, values, 1.50),
      platinumPreferredRewardsBarGraph: 3 + this.MathFuncs.barGraphHeight(rewards, max, 2.8),
      platinumPreferredRewardsBarGraphMobile: 3 + this.MathFuncs.barGraphHeight(rewards, max, 0.7),
      platinumPreferredRewardsTravel: this.MathFuncs.travel(valuesObj, 1.5),
      // Preferred Rewards Platinum Honors Graph... yes the name is wrong
      goldHonorsPreferredRewards: this.MathFuncs.rewards(rewards, 1.75),
      goldHonorsPreferredRewardsPercentage: this.MathFuncs.percentages(rewards, values, 1.75),
      goldHonorsPreferredRewardsBarGraph: 3 + this.MathFuncs.barGraphHeight(rewards, max, 3.4),
      goldHonorsPreferredRewardsBarGraphMobile: 3 + this.MathFuncs.barGraphHeight(rewards, max, 0.9),
      goldHonorsPreferredRewardsTravel: this.MathFuncs.travel(valuesObj, 1.75)
    };

    // Max rewards value will always be the platinum honors tier
    max = this.barGraphCalculations.goldHonorsPreferredRewardsBarGraph;

    // Determine margins around the graphs based on the calculated values.
    const margins = {
      regular: max - this.barGraphCalculations.cashBackRewardsBarGraph,
      checking: max - this.barGraphCalculations.checkCustomerBonusBarGraph,
      prgold: max - this.barGraphCalculations.goldPreferredRewardsBarGraph,
      prplatinum: max - this.barGraphCalculations.platinumPreferredRewardsBarGraph
    };
    const {
      bargraphClassnames
    } = this.settings;
    const setStyles = (selector, style, value) => {
      if (selector) {
        selector.style[style] = `${value}px`;
      }
    };

    // Apply css updates to increase/decrease the size of the graphs.

    const {
      target
    } = this.settings;
    setStyles(target.querySelector(`.show-for-small-only ${bargraphClassnames.NON_CUST} .bar-graph-visual`), 'width', this.barGraphCalculations.cashBackRewardsBarGraphMobile);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.NON_CUST}`), 'marginTop', margins.regular);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.NON_CUST} .bar-graph-visual`), 'width', this.barGraphCalculations.cashBackRewardsBarGraph);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.NON_CUST} .bar-graph-visual-upward`), 'height', this.barGraphCalculations.cashBackRewardsBarGraph);
    setStyles(target.querySelector(`.show-for-small-only ${bargraphClassnames.CUST} .bar-graph-visual`), 'width', this.barGraphCalculations.checkCustomerBonusBarGraphMobile);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.CUST} .bar-graph-visual`), 'marginTop', margins.checking);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.CUST} .bar-graph-visual-upward`), 'width', this.barGraphCalculations.checkCustomerBonusBarGraph);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.CUST} .bar-graph-visual-upward`), 'height', this.barGraphCalculations.checkCustomerBonusBarGraph);
    setStyles(target.querySelector(`.show-for-small-only ${bargraphClassnames.GOLD_CUST} .bar-graph-visual`), 'width', this.barGraphCalculations.goldPreferredRewardsBarGraphMobile);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.GOLD_CUST}`), 'marginTop', margins.prgold);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.GOLD_CUST} .bar-graph-visual`), 'width', this.barGraphCalculations.goldPreferredRewardsBarGraph);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.GOLD_CUST} .bar-graph-visual-upward`), 'height', this.barGraphCalculations.goldPreferredRewardsBarGraph);
    setStyles(target.querySelector(`.show-for-small-only ${bargraphClassnames.PLAT_CUST} .bar-graph-visual`), 'width', this.barGraphCalculations.platinumPreferredRewardsBarGraphMobile);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.PLAT_CUST}`), 'marginTop', margins.prplatinum);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.PLAT_CUST} .bar-graph-visual`), 'width', this.barGraphCalculations.platinumPreferredRewardsBarGraph);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.PLAT_CUST} .bar-graph-visual-upward`), 'height', this.barGraphCalculations.platinumPreferredRewardsBarGraph);
    setStyles(target.querySelector(`.show-for-small-only ${bargraphClassnames.PLAT_HONOR_CUST} .bar-graph-visual`), 'width', this.barGraphCalculations.goldHonorsPreferredRewardsBarGraphMobile);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.PLAT_HONOR_CUST} .bar-graph-visual`), 'width', this.barGraphCalculations.goldHonorsPreferredRewardsBarGraph);
    setStyles(target.querySelector(`.show-for-medium-up ${bargraphClassnames.PLAT_HONOR_CUST} .bar-graph-visual-upward`), 'height', this.barGraphCalculations.goldHonorsPreferredRewardsBarGraph);
    $(this.settings.target)

    // Cash back rewards bar graph
    .find(bargraphClassnames.NON_CUST).find('.rewards-total').text(rewardsCalcCcModuleJS.commaSeparateNumber(this.barGraphCalculations.cashBackRewards)).end().find('.bar-graph-cash-back span').text(this.barGraphCalculations.cashBackRewardsPercentage).end().find('.bar-graph-points span').text(rewardsCalcCcModuleJS.commaSeparateNumber(this.barGraphCalculations.cashBackRewardsTravel)).end().end()

    // Customer bonus rewards bar graph
    .find(bargraphClassnames.CUST).find('.rewards-total').text(rewardsCalcCcModuleJS.commaSeparateNumber(this.barGraphCalculations.checkCustomerBonus)).end().find('.bar-graph-cash-back span').text(this.barGraphCalculations.checkCustomerBonusPercentage).end().find('.bar-graph-points span').text(rewardsCalcCcModuleJS.commaSeparateNumber(this.barGraphCalculations.checkCustomerBonusTravel)).end().end()

    // Gold preferred rewards bar graph
    .find(bargraphClassnames.GOLD_CUST).find('.rewards-total').text(rewardsCalcCcModuleJS.commaSeparateNumber(this.barGraphCalculations.goldPreferredRewards)).end().find('.bar-graph-cash-back span').text(this.barGraphCalculations.goldPreferredRewardsPercentage).end().find('.bar-graph-points span').text(rewardsCalcCcModuleJS.commaSeparateNumber(this.barGraphCalculations.goldPreferredRewardsTravel)).end().end()

    // Platinum preferred rewards bar graph
    .find(bargraphClassnames.PLAT_CUST).find('.rewards-total').text(rewardsCalcCcModuleJS.commaSeparateNumber(this.barGraphCalculations.platinumPreferredRewards)).end().find('.bar-graph-cash-back span').text(this.barGraphCalculations.platinumPreferredRewardsPercentage).end().find('.bar-graph-points span').text(rewardsCalcCcModuleJS.commaSeparateNumber(this.barGraphCalculations.platinumPreferredRewardsTravel)).end().end()

    // Platinum honors rewards bar graph
    .find(bargraphClassnames.PLAT_HONOR_CUST).find('.rewards-total').text(rewardsCalcCcModuleJS.commaSeparateNumber(this.barGraphCalculations.goldHonorsPreferredRewards)).end().find('.bar-graph-cash-back span').text(this.barGraphCalculations.goldHonorsPreferredRewardsPercentage).end().find('.bar-graph-points span').text(rewardsCalcCcModuleJS.commaSeparateNumber(this.barGraphCalculations.goldHonorsPreferredRewardsTravel)).end().end();
  }

  /**
   * Reset all bar graphs back to initial sizes/values upon changing the timespan.
   * @returns {void}
   */
  resetBarGraphs() {
    const {
      bargraphClassnames
    } = this.settings;
    Object.keys(bargraphClassnames).forEach(className => {
      $(this.settings.target).find(`.show-for-medium-up ${bargraphClassnames[className]}`).css('margin-top', 0).end();
    });
    $(this.settings.target).find('.bar-graph-visual').css('width', 3).end().find('.bar-graph-points span').text(0).end().find('.bar-graph-cash-back span').text(0).end().find('.rewards-total').text('0.00').end().find('.rewards-percentage').text(0).end().find('.bar-graph-visual').css('width', 3).end().find('.bar-graph-visual-upward').css('height', 3).end();
  }

  /**
   * Handler for changing the timespan of rewards
   * @returns {void}
   */
  durationSelectionChanged() {
    const timespan = this.durationSel.value;
    const selectContainers = document.querySelectorAll('.slider-value-wrapper');
    this.sliders = this.sliders.map(this.mapSliderProps.bind(this, timespan));
    const {
      desc,
      note
    } = this.sliders[0].content;
    if (desc) {
      this.sliderSection.querySelector('.spending-header-text').innerHTML = desc;
    }
    if (note) {
      this.sliderSection.querySelector('.spending-note').innerHTML = note;
    }
    this.sliders.forEach(slider => {
      this.updateSliderRange(slider, 0, slider.max);
      slider.curValue = 0;
      slider.rewards = 0;
    });
    selectContainers.forEach(container => {
      container.setAttribute('value', 0);
    });
    this.updateBarGraphs();
    this.resetBarGraphs();
  }

  /**
   * Event handler for slider duration selector
   * @param {Object} e - change event
   * @returns {void}
   */
  sliderSelectChanged(e) {
    const el = e.target;
    const elParent = el.parentElement.offsetParent;
    const selectContainer = elParent.querySelector('.slider-value-wrapper');
    selectContainer.setAttribute('value', el.value);
  }

  /**
   * Initializes the show/hide details spans as links to show/hide details content for card info on calculator page
   * @returns {void}
   */
  initShowHideDetails() {
    let link;
    const details = this.cardDisplaySection.querySelector('p.details');
    if (details) {
      details.style.marginBottom = '0px';
      const showDetailsSpan = this.cardDisplaySection.querySelector('.showDetails');
      const hideDetailsSpan = this.cardDisplaySection.querySelector('.hideDetails');
      // Wrap the elements in an <a> tag
      [showDetailsSpan, hideDetailsSpan].forEach(el => {
        link = document.createElement('a');
        link.innerHTML = el.outerHTML;
        link.setAttribute('href', 'javascript:void(0);'); // eslint-disable-line
        link.classList.add(el.classList[0]);
        link.classList.add('detailsLink'); // Have to split it out due to IE
        el.parentNode.insertBefore(link, el);
        if (!('remove' in Element.prototype)) {
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }
        } else {
          el.remove();
        }
      });
      creditCardUtility.delegateEvent('click', 'a.detailsLink', this.toggleActiveClass.bind(this), false, this.settings.target);
    }
  }

  /**
   * Toggles the active class on the card display section
   * @returns {void}
   */
  toggleActiveClass() {
    this.cardDisplaySection.classList.toggle('active');
  }

  /**
   * Modifies the language link in engagement section
   * @returns {void}
   */
  pageUrlAppend() {
    const aLink = this.engagementSection.querySelector('#esp-route-to');
    if (!aLink) return;
    const dataRedirect = aLink.dataset.redirect;
    if (window.location.search.indexOf('hidecard') > -1) {
      aLink.setAttribute('href', dataRedirect);
    }
  }

  /**
   * Handler for increment and decrement buttons on slider
   * @param {Object} e - event
   * @returns{void}
   */
  incrementDecrement(e) {
    if (e.type === 'click' || e.key === 'Enter') {
      const el = e.target;
      const elParent = el.parentElement;
      const selectContainer = elParent.querySelector('.slider-value-wrapper');
      const selectContainerValueString = selectContainer.getAttribute('value');
      const step = parseInt(el.dataset.step, 10);
      let elValue = parseInt(selectContainerValueString, 10);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(elValue)) {
        elValue = 0;
      }
      const plus = el.classList.contains('slider-plus');
      let sliderValue;
      if (plus) {
        sliderValue = elValue + step;
        const maxValue = rewardsCalcCcModuleJS.formatToNumber(el.getAttribute('aria-valuemax'));
        if (sliderValue > maxValue) return;
        selectContainer.value = sliderValue;
        selectContainer.setAttribute('value', sliderValue);
        this.Events.pub(creditCardUtility.EVENTS.valueChange);
      } else {
        sliderValue = elValue - step;
        const minValue = rewardsCalcCcModuleJS.formatToNumber(el.getAttribute('aria-valuemin'));
        if (sliderValue < minValue) return;
        selectContainer.value = sliderValue;
        selectContainer.setAttribute('value', sliderValue);
        this.Events.pub(creditCardUtility.EVENTS.valueChange);
      }
      // add ADA attributes
      const formattedValue = `$${rewardsCalcCcModuleJS.commaSeparateNumber(sliderValue)}`;
      const buttons = el.parentElement.parentElement.querySelectorAll('.round');
      [...buttons].forEach(button => {
        button.setAttribute('aria-valuenow', formattedValue);
      });
    }
  }

  /* Private Functions */

  /**
   * Handle keypress when slider handle is focused
   * @param {Event} e - keypress event
   * @param {Element} sliderRow - row being manipulated
   * @returns {void}
   */
  static doHandleKeyPress(e, sliderRow) {
    let handled = true;
    switch (e.keyCode) {
      case 9:
        // Tab
        handled = false;
        break;
      case 37:
        // left
        sliderRow.querySelector('.slider-minus').click();
        break;
      case 39:
        // right
        sliderRow.querySelector('.slider-plus').click();
        break;
      default:
        handled = false;
    }
    // If events handled, stop propagation
    if (handled) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  /**
   * Helper function for building an object of select options and their values.
   * Structured as following:
   * {
   *    numericValue: <text to be displayed>
   * }
   * @param {Number} max - maximum value for this slider
   * @returns {Object} increments - the object containing the select options for this slider
   */
  static buildSliderIncrements(max) {
    const increments = {};

    // IE11 becomes unresponsive, increment by 1k for 1m or more max
    const increment = max >= 1000000 ? 1000 : 100;
    for (let i = increment; i <= max; i += increment) {
      increments[i] = `$${rewardsCalcCcModuleJS.commaSeparateNumber(i)}`;
    }
    return increments;
  }

  /**
   * Converts a string to snake case using regex.
   * @param {String} s - string to convert to snake case
   * @returns {String} The altered string
   */
  static stringToSnakeCase(s) {
    let stringResult = '';
    if (typeof s === 'string') {
      stringResult = s.replace(/\s+/g, '-').toLowerCase();
    }
    return stringResult;
  }

  /**
   * Converts a string to camel case using regex.
   * @param {String} s - string to convert to camel case
   * @returns {String} The altered string
   */
  static stringToCamelCase(s) {
    let stringResult = '';
    if (typeof s === 'string') {
      stringResult = s.replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) => index === 0 ? letter.toLowerCase() : letter.toUpperCase()).replace(/\s+/g, '');
    }
    return stringResult;
  }

  /**
   * Converts a number to a comma-separated string
   * @method rewardsCalcCcModuleJS.commaSeparateNumber
   * @param {Number} val - The number to comma-separate
   * @returns {String} The value converted to a string with comma separation
   */
  static commaSeparateNumber(val) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * Sorts items in ascending order based on percentage field
   * @param {Number} a - first item
   * @param {Number} b - second item
   * @returns {Number} the sorted item
   */
  static sortAsc(a, b) {
    return a.percentage - b.percentage;
  }

  /**
   * Sorts items in descending order based on percentage field
   * @param {Number} a - first item
   * @param {Number} b - second item
   * @returns {Number} the sorted item
   */
  static sortDesc(a, b) {
    return b.percentage - a.percentage;
  }

  /**
   * Format value from a number input
   * @param {String} value Input value
   * @returns {Number} Number-formatted value
   */
  static formatToNumber(value) {
    return Number(value.toString().replace(/[^\d.]/g, ''));
  }
}
registerModuleClass({
  moduleClass: rewardsCalcCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { rewardsCalcCcModuleJS as default, moduleConfig };
